module.exports = __webpack_public_path__ + "src/components/Ranktable/icon-mind.png?4f1bf619";


//////////////////
// WEBPACK FOOTER
// ./src/components/Ranktable/icon-mind.png
// module id = 2818
// module chunks = 1